/** Stable install identities: rack URLs must not inherit the work tablet's manifest. */
export const isRackTabletPath = (path: string) => {
  const pathname = path.split(/[?#]/, 1)[0];
  return pathname === "/rack-tablet" || pathname.startsWith("/rack-tablet/");
};

export const tabletPwaForPath = (path: string) => isRackTabletPath(path)
  ? { manifest: "/rack-manifest.webmanifest", appTitle: "랙 태블릿" }
  : { manifest: "/manifest.webmanifest", appTitle: "태블릿 작업" };

export function updateTabletPwaHead(document: Document, path: string) {
  const profile = tabletPwaForPath(path);
  const manifest = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (manifest && manifest.getAttribute("href") !== profile.manifest) manifest.setAttribute("href", profile.manifest);
  const title = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
  if (title && title.content !== profile.appTitle) title.content = profile.appTitle;
}
